export default {
  path: "/SectionContent/OccupantInformation",
  name: "Occupant Information",
  htmlContent: "occupant_information.html",
  headings: [
    { id: "n98Name", text: "98. Name", type: "field" },
    { id: "n99Address", text: "99. Address", type: "field" },
    { id: "n100Age", text: "100. Age", type: "field" },
    { id: "n101Sex", text: "101. Sex", type: "field" },
    { id: "n102Unit", text: "102. Unit #", type: "field" },
    { id: "n103SeatingPosition", text: "103. Seating Position", type: "field" },
    { id: "n104SafetyEquipment", text: "104. Safety Equipment", type: "field" },
    { id: "n105Ejected", text: "105. Ejected", type: "field" },
    { id: "n106Extricated", text: "106. Extricated", type: "field" },
    { id: "n107AirBagFunction", text: "107. Air Bag Function", type: "field" },
    { id: "n108Injury", text: "108. Injury", type: "field" },
    { id: "n109TakenForTreatment", text: "109. Taken for Treatment", type: "field" },
    { id: "n110InjuredTakenTo", text: "110. Injured Taken To", type: "field" },
    { id: "n111By", text: "111. By", type: "field" },
    { id: "n112EMSNotifiedTime", text: "112. EMS Notified Time", type: "field" },
    { id: "n113EMSArrivalTime", text: "113. EMS Arrival Time", type: "field" },
    { id: "n114HospitalArrivalTime", text: "114. Hospital Arrival Time", type: "field" },
  ],
};
